module.exports = __webpack_public_path__ + "media/images/front/menu_db04-2ecde0c2a2dbc640cc72f767ff304ace.jpg";